import { render, staticRenderFns } from "./addRecruitCompany.vue?vue&type=template&id=48ce139a"
import script from "./addRecruitCompany.vue?vue&type=script&lang=js"
export * from "./addRecruitCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports